export const splitImageFileName = (imgUrl) => {
  if (!imgUrl) return '';
  const split = imgUrl.split('/');
  return split[split.length - 1];
};
